import { navbar, toTop } from "../elements";

export function useStickNav() {
  if (!navbar) return;

  function stickyNav() {
    if (window.scrollY > 100) {
      navbar.classList.add("sticky");
      toTop && toTop.classList.add("visible");
    } else if (window.scrollY === 0) {
      navbar.classList.remove("sticky");
      toTop && toTop.classList.remove("visible");
    }
  }

  stickyNav();
  window.addEventListener("scroll", stickyNav);
}
